import { render, staticRenderFns } from "./MBHeaderNav.vue?vue&type=template&id=f56a73b2&scoped=true"
import script from "./MBHeaderNav.vue?vue&type=script&lang=js"
export * from "./MBHeaderNav.vue?vue&type=script&lang=js"
import style0 from "./MBHeaderNav.vue?vue&type=style&index=0&id=f56a73b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56a73b2",
  null
  
)

export default component.exports